import styled from 'styled-components';
export const ContentfulLinkAnchor = styled.a ``;
